/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';
// @ts-ignore
import { PeriodoRendicontazioneDTO } from '../model/periodo-rendicontazione-dto';
// @ts-ignore
import { RendicontazioneEsercenteDTO } from '../model/rendicontazione-esercente-dto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    EsercenteRendicontazioneServiceInterface,
    DownloadFileRendicontazioneEsercenteRequestParams,
    DownloadNotaDebitoRendicontazioneEsercenteRequestParams,
    GetRendicontazioneEsercenteRequestParams,
    ListPeriodiRendicontazioneEsercenteRequestParams,
    SubmitRendicontazioneEsercenteRequestParams
} from './esercente-rendicontazione.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class EsercenteRendicontazioneService extends BaseService implements EsercenteRendicontazioneServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Scarica il file nota firmata / controfirmata caricato (self-service).
     * ?controfirmata&#x3D;true per la controfirmata. Owner-check → 404 cross-esercente; file non valorizzato → 404.
     * @endpoint get /api/v1/esercente/rendicontazioni/{id_rendicontazione}/file
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public downloadFileRendicontazioneEsercente(requestParameters: DownloadFileRendicontazioneEsercenteRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Blob>;
    public downloadFileRendicontazioneEsercente(requestParameters: DownloadFileRendicontazioneEsercenteRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Blob>>;
    public downloadFileRendicontazioneEsercente(requestParameters: DownloadFileRendicontazioneEsercenteRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Blob>>;
    public downloadFileRendicontazioneEsercente(requestParameters: DownloadFileRendicontazioneEsercenteRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/octet-stream' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idRendicontazione = requestParameters?.idRendicontazione;
        if (idRendicontazione === null || idRendicontazione === undefined) {
            throw new Error('Required parameter idRendicontazione was null or undefined when calling downloadFileRendicontazioneEsercente.');
        }
        const controfirmata = requestParameters?.controfirmata;

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'controfirmata',
            <any>controfirmata,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/octet-stream',
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let localVarPath = `/api/v1/esercente/rendicontazioni/${this.configuration.encodeParam({name: "idRendicontazione", value: idRendicontazione, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/file`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: "blob",
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Scarica il PDF nota di debito di una propria rendicontazione (self-service).
     * PDF generato on-the-fly. Owner-check: rendicontazione di altro esercente → 404.
     * @endpoint get /api/v1/esercente/rendicontazioni/{id_rendicontazione}/nota-debito
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public downloadNotaDebitoRendicontazioneEsercente(requestParameters: DownloadNotaDebitoRendicontazioneEsercenteRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Blob>;
    public downloadNotaDebitoRendicontazioneEsercente(requestParameters: DownloadNotaDebitoRendicontazioneEsercenteRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Blob>>;
    public downloadNotaDebitoRendicontazioneEsercente(requestParameters: DownloadNotaDebitoRendicontazioneEsercenteRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Blob>>;
    public downloadNotaDebitoRendicontazioneEsercente(requestParameters: DownloadNotaDebitoRendicontazioneEsercenteRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idRendicontazione = requestParameters?.idRendicontazione;
        if (idRendicontazione === null || idRendicontazione === undefined) {
            throw new Error('Required parameter idRendicontazione was null or undefined when calling downloadNotaDebitoRendicontazioneEsercente.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/pdf',
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let localVarPath = `/api/v1/esercente/rendicontazioni/${this.configuration.encodeParam({name: "idRendicontazione", value: idRendicontazione, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/nota-debito`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: "blob",
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Rendicontazione di un periodo per una propria domanda (compute on-read).
     * Compute idempotente se DA_SOTTOMETTERE. Owner-check via il profilo del caller: una domanda di un altro esercente → 404 privacy-preserving.
     * @endpoint get /api/v1/esercente/rendicontazioni/periodi/{id_periodo}/pratiche/{id_pratica_esercente}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getRendicontazioneEsercente(requestParameters: GetRendicontazioneEsercenteRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<RendicontazioneEsercenteDTO>;
    public getRendicontazioneEsercente(requestParameters: GetRendicontazioneEsercenteRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<RendicontazioneEsercenteDTO>>;
    public getRendicontazioneEsercente(requestParameters: GetRendicontazioneEsercenteRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<RendicontazioneEsercenteDTO>>;
    public getRendicontazioneEsercente(requestParameters: GetRendicontazioneEsercenteRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idPeriodo = requestParameters?.idPeriodo;
        if (idPeriodo === null || idPeriodo === undefined) {
            throw new Error('Required parameter idPeriodo was null or undefined when calling getRendicontazioneEsercente.');
        }
        const idPraticaEsercente = requestParameters?.idPraticaEsercente;
        if (idPraticaEsercente === null || idPraticaEsercente === undefined) {
            throw new Error('Required parameter idPraticaEsercente was null or undefined when calling getRendicontazioneEsercente.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/esercente/rendicontazioni/periodi/${this.configuration.encodeParam({name: "idPeriodo", value: idPeriodo, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/pratiche/${this.configuration.encodeParam({name: "idPraticaEsercente", value: idPraticaEsercente, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<RendicontazioneEsercenteDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Periodi di rendicontazione di un bando (self-service).
     * Self-scoped: solo i bandi a cui il caller ha una propria domanda; bando senza stake → 404 privacy-preserving.
     * @endpoint get /api/v1/esercente/rendicontazioni/tipi-pratica/{id_tipo_pratica}/periodi
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listPeriodiRendicontazioneEsercente(requestParameters: ListPeriodiRendicontazioneEsercenteRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<PeriodoRendicontazioneDTO>>;
    public listPeriodiRendicontazioneEsercente(requestParameters: ListPeriodiRendicontazioneEsercenteRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<PeriodoRendicontazioneDTO>>>;
    public listPeriodiRendicontazioneEsercente(requestParameters: ListPeriodiRendicontazioneEsercenteRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<PeriodoRendicontazioneDTO>>>;
    public listPeriodiRendicontazioneEsercente(requestParameters: ListPeriodiRendicontazioneEsercenteRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling listPeriodiRendicontazioneEsercente.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/esercente/rendicontazioni/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/periodi`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<PeriodoRendicontazioneDTO>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Sottomissione della nota di debito firmata (self-service).
     * Multipart: part \&#39;nota\&#39; (file obbligatorio → 422 se assente). Upload S3 + transizione {DA_SOTTOMETTERE, RIFIUTATA} → SOTTOMESSA atomici. Periodo non ABILITATO → 422.
     * @endpoint post /api/v1/esercente/rendicontazioni/periodi/{id_periodo}/pratiche/{id_pratica_esercente}/submit
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public submitRendicontazioneEsercente(requestParameters: SubmitRendicontazioneEsercenteRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<RendicontazioneEsercenteDTO>;
    public submitRendicontazioneEsercente(requestParameters: SubmitRendicontazioneEsercenteRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<RendicontazioneEsercenteDTO>>;
    public submitRendicontazioneEsercente(requestParameters: SubmitRendicontazioneEsercenteRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<RendicontazioneEsercenteDTO>>;
    public submitRendicontazioneEsercente(requestParameters: SubmitRendicontazioneEsercenteRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idPeriodo = requestParameters?.idPeriodo;
        if (idPeriodo === null || idPeriodo === undefined) {
            throw new Error('Required parameter idPeriodo was null or undefined when calling submitRendicontazioneEsercente.');
        }
        const idPraticaEsercente = requestParameters?.idPraticaEsercente;
        if (idPraticaEsercente === null || idPraticaEsercente === undefined) {
            throw new Error('Required parameter idPraticaEsercente was null or undefined when calling submitRendicontazioneEsercente.');
        }
        const nota = requestParameters?.nota;

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        localVarUseForm = canConsumeForm;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (nota !== undefined) {
            localVarFormParams = localVarFormParams.append('nota', <any>nota) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/esercente/rendicontazioni/periodi/${this.configuration.encodeParam({name: "idPeriodo", value: idPeriodo, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/pratiche/${this.configuration.encodeParam({name: "idPraticaEsercente", value: idPraticaEsercente, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/submit`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<RendicontazioneEsercenteDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
